const RecentJobSkeleton = ({ isTitle, numberOfCols = 6 }: any) => {
  const cols = typeof numberOfCols === "number" ? numberOfCols : 6;
  return (
    <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 sm:cht-py-16">
      {isTitle && (
        <header className="cht-text-center cht-mb-10 sm:cht-mb-12 cht-space-y-3">
          <div className="cht-h-8 cht-w-64 cht-bg-slate-200 cht-rounded-xl cht-mx-auto cht-animate-pulse" />
          <div className="cht-h-4 cht-w-80 cht-bg-slate-100 cht-rounded-lg cht-mx-auto cht-animate-pulse" />
        </header>
      )}
      <div className="cht-grid cht-grid-cols-1 sm:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
        {Array.from({ length: cols }).map((_, index) => (
          <div
            key={index}
            className="cht-bg-white cht-rounded-[22px] cht-border cht-border-slate-200/80 cht-overflow-hidden cht-shadow-soft cht-animate-pulse"
          >
            <div className="cht-aspect-[16/9] cht-bg-slate-200/80 cht-w-full" />
            <div className="cht-p-5 sm:cht-p-6 cht-space-y-3">
              <div className="cht-h-4 cht-w-20 cht-bg-slate-200 cht-rounded-md" />
              <div className="cht-h-5 cht-w-4/5 cht-bg-slate-200 cht-rounded-lg" />
              <div className="cht-h-3.5 cht-w-1/3 cht-bg-slate-100 cht-rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecentJobSkeleton;
